"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoRestExtension = void 0;
const vscode_jsonrpc_1 = require("vscode-jsonrpc");
const extension_host_1 = require("./extension-host");
const types_1 = require("./types");
var IAutoRestPluginTargetTypes;
(function (IAutoRestPluginTargetTypes) {
    IAutoRestPluginTargetTypes.GetPluginNames = new vscode_jsonrpc_1.RequestType0("GetPluginNames");
    IAutoRestPluginTargetTypes.Process = new vscode_jsonrpc_1.RequestType2("Process");
})(IAutoRestPluginTargetTypes || (IAutoRestPluginTargetTypes = {}));
class AutoRestExtension {
    constructor() {
        this.plugins = {};
    }
    add(name, handler) {
        this.plugins[name] = handler;
    }
    async run(input = process.stdin, output = process.stdout) {
        // connection setup
        const channel = (0, vscode_jsonrpc_1.createMessageConnection)(input, output, {
            error(message) {
                // eslint-disable-next-line no-console
                console.error("rpc:error: ", message);
            },
            info(message) {
                // eslint-disable-next-line no-console
                console.error("rpc:info: ", message);
            },
            log(message) {
                // eslint-disable-next-line no-console
                console.error("rpc:log: ", message);
            },
            warn(message) {
                // eslint-disable-next-line no-console
                console.error("rpc:warn: ", message);
            },
        });
        channel.onRequest(IAutoRestPluginTargetTypes.GetPluginNames, async () => Object.keys(this.plugins));
        channel.onRequest(IAutoRestPluginTargetTypes.Process, async (pluginName, sessionId) => {
            const host = new extension_host_1.AutorestExtensionRpcHost(channel, sessionId);
            try {
                const handler = this.plugins[pluginName];
                if (!handler) {
                    throw new Error(`Plugin host could not find requested plugin '${pluginName}'.`);
                }
                await handler(host);
                return true;
            }
            catch (e) {
                if (await host.getValue("debug")) {
                    // eslint-disable-next-line no-console
                    console.error(`PLUGIN FAILURE: ${e.message}, ${e.stack}, ${JSON.stringify(e, null, 2)}`);
                }
                host.message({
                    Channel: types_1.Channel.Fatal,
                    Text: "" + e,
                    Details: e,
                });
                return false;
            }
        });
        // activate
        channel.listen();
    }
    /**
     * @deprecated Use #add
     */
    Add(name, handler) {
        return this.add(name, handler);
    }
    /**
     * @deprecated Use #run
     */
    Run(input = process.stdin, output = process.stdout) {
        return this.run(input, output);
    }
}
exports.AutoRestExtension = AutoRestExtension;
//# sourceMappingURL=autorest-extension.js.map